/**
 * TripActionCreator - Can be used for trip related actions like create, edit, delete for trips and trip transactions
 */

import * as constants from "./../constants";
import { getDateInStringDDMMMYYYY, getAvatarStringFromName, getVehicleNumberValues, getVehicleNumberValuesDWeb } from "./utils/utils";
import { findArrayObject, pos_to_neg,spaceOnly } from "../../utils/utils";

import * as logger from './../../logger';

export const getPartyList = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/customers",
    data,
    success: (response) => populatePartyList(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const getSupplierListV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/list/vendor?pageNo=${data.pageNo}&pageSize=${data.pageSize}${data && data.search?`&search=${data.search}`:''}`,
    data,
    success: (response) => populateSupplierListV2(response,data&&data.merge?data.merge:false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const populateSupplierListV2 = (partyListResponse,merge) => {
  var payloadData =partyListResponse.response;
  if (partyListResponse && partyListResponse.status && partyListResponse.status.code == 200) {
    let suppliers = payloadData.suppliers;
    for (var i = 0; i < suppliers.length; i++) {
      suppliers[i]['vendorName']=suppliers[i]['name'];
      suppliers[i]['vendorNumber']=suppliers[i]['contactNumber'];
      suppliers[i]['listText'] = suppliers[i]['name'] + suppliers[i]['contactNumber'];
      suppliers[i]['avatarString'] = getAvatarStringFromName(suppliers[i]['name']);
    }
    payloadData.suppliers = suppliers;
  }
  return { type: constants.GET_SUPPLIER_LIST, payload: {payloadData:payloadData,merge:merge} };
}
export const getDriverListV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/list/driver?pageNo=${data.pageNo}&pageSize=${data.pageSize}${data && data.search?`&search=${data.search}`:''}`,
    data,
    success: (response) => populateDriverListV2(response,data&&data.merge?data.merge:false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const populateDriverListV2 = (response,merge) => {
  var payloadData =response.response;
  if (response && response.status && response.status.code == 200) {
    let drivers = payloadData.drivers;
    for (var i = 0; i < drivers.length; i++) {
      drivers[i]['listText'] = drivers[i]['name'] + drivers[i]['contactNumber'];
      drivers[i]['avatarString'] = getAvatarStringFromName(drivers[i]['name']);
    }
    payloadData.drivers = drivers;
  }
  return { type: constants.GET_DRIVER_LIST, payload: {payloadData:payloadData,merge:merge} };
}
export const getPartyListV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/list/customer?pageNo=${data.pageNo}&pageSize=${data.pageSize}${data && data.search?`&search=${data.search}`:''}`,
    data,
    success: (response) => populatePartyListV2(response,data&&data.merge?data.merge:false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const populatePartyListV2 = (partyListResponse,merge) => {
  var payloadData =partyListResponse.response;
  if (partyListResponse && partyListResponse.status && partyListResponse.status.code == 200) {
    let parties = payloadData.parties;
    for (var i = 0; i < parties.length; i++) {
      parties[i]['customerId']=parties[i]['id'];
      parties[i]['listText'] = parties[i]['name'] + parties[i]['contactNumber'];
      parties[i]['avatarString'] = getAvatarStringFromName(parties[i]['name']);
    }
    payloadData.parties = parties;
  }
  return { type: constants.GET_PARTY_LIST, payload: {payloadData:payloadData,merge:merge} };
}
export const getVehicleListV2 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/list/vehicle?pageNo=${data.pageNo}&pageSize=${data.pageSize}${data && data.search?`&search=${data.search}`:''}`,
    data,
    success: (response) => populateVehicleListV2(response,data&&data.merge?data.merge:false),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const populateVehicleListV2 = (partyListResponse,merge) => {
  var payloadData =partyListResponse.response;
  if (partyListResponse && partyListResponse.status && partyListResponse.status.code == 200) {
    let vehicles = payloadData.trucks;
    for (var i = 0; i < vehicles.length; i++) {
      var vehicleNumArray = getVehicleNumberValues(vehicles[i].vehicleNumber)
      var vehicleNumArrayValue = getVehicleNumberValuesDWeb(vehicles[i].vehicleNumber);
      var vehicleDisplayStatus = vehicles[i].status ? constants.VEHICLE_STATUS[vehicles[i].status] : ''
      vehicles[i].vehicleNumberPrefix= vehicleNumArray[0];
      vehicles[i].vehicleNumberSuffix= vehicleNumArray[1];
      vehicles[i].vehicleNumArrayDweb= vehicleNumArrayValue;
    }
    payloadData.vehicles = vehicles;
  }
  return { type: constants.GET_VEHICLE_LIST, payload: {payloadData:payloadData,merge:merge} };
}
export const emptyPartyList = (data, onSuccess, onError) => ({ type: constants.GET_PARTY_LIST, payload: [] });
export const emptyShopList = (data, onSuccess, onError) => ({ type: constants.GET_PARTY_LIST, payload: [] });

const populatePartyList = (partyListResponse) => {
  var payloadData = []
  if (partyListResponse && partyListResponse.status && partyListResponse.status.code == 200 && partyListResponse.customers && partyListResponse.customers.length > 0) {
    payloadData = partyListResponse.customers;
    for (var i = 0; i < payloadData.length; i++) {
      payloadData[i]['listText'] = payloadData[i]['name'] + payloadData[i]['contactNumber'];
      payloadData[i]['avatarString'] = getAvatarStringFromName(payloadData[i]['name']);
    }
  }
  return { type: constants.GET_PARTY_LIST, payload: payloadData };
}

export const getSuggestedLocations = (customerId, vehicleId, locationType, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/location/suggested?customer=" + customerId + "&vehicle=" + vehicleId + "&locationType=" + locationType,
    data,
    success: (response) => populateSuggestedLocationsList(locationType, response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});

const populateSuggestedLocationsList = (locationType, locationListResponse) => {
  var payloadData = []
  if (locationListResponse && locationListResponse.status && locationListResponse.status.code == 200 && locationListResponse.response && locationListResponse.response.length > 0) {
    payloadData = locationListResponse.response;
  }
  if (locationType == "origin")
    return { type: constants.GET_CREATE_TRIP_ORIGIN_LOCATIONS, payload: payloadData };
  else
    return { type: constants.GET_CREATE_TRIP_DEST_LOCATIONS, payload: payloadData };
}

export const addCustomLocation = (name, locationType) => ({
  type: constants.ADD_CUSTOM_LOCATION,
  payload: { name, locationType }
});

export const addCustomLocationProfile = (name) => ({
  type: constants.ADD_CUSTOM_LOCATION_PROFILE,
  payload: name
});

export const getTripDetails = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trips/" + tripId,
    tripId,
    success: (response) => populateSingleTripData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getTripDetailsV3 = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trips-v3/" + tripId,
    tripId,
    success: (response) => populateSingleTripData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getJourneyDetails = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/journey/" + tripId,
    tripId,
    success: (response) => populateSingleJourneyData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getTripDetailsOnly = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trips-v3/" + tripId,
    tripId,
    success: (response) => processGetTripDetailsOnly(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const processGetTripDetailsOnly = (response) => {
  return { type: null, payload: null };
}
export const updateTrip = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId,
    data,
    success: (response) => populateSingleTripData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const updateJourney = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/journey/" + tripId,
    data,
    success: (response) => populateSingleJourneyData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deleteTrip = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId,
    success: (response) => processDeleteTripResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const deleteTripJourney = (journeyId,tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url:`/journey/${journeyId}/trip/${tripId}`,
    success: (response) => processDeleteTripResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processDeleteTripResponse = (response) => {
  logger.log("TripActionCreator", "----> INCOMING DELETE TRIP RESPONSE : " + JSON.stringify(response))
  return { type: null, payload: null };
}

export const getTripShareDetails = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trip_share/" + tripId,
    tripId,
    success: (response) => populateSingleTripShareData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const getVendorTripShareDetails = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/vendor_trip_share/" + tripId,
    tripId,
    success: (response) => populateSingleTripShareData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const populateSingleTripShareData = (response) => {
  var payloadData = response.response;
  var vehicleNumber = payloadData.vehicle && payloadData.vehicle.number ? payloadData.vehicle.number : '';
  payloadData.vehicleNumberPrefix = vehicleNumber.substring(0, vehicleNumber.length - 4);
  payloadData.vehicleNumberSuffix = vehicleNumber.substring(vehicleNumber.length - 4, vehicleNumber.length)
  payloadData.vehicleType = payloadData.vehicle && payloadData.vehicle.type ? payloadData.vehicle.type : '';
  payloadData.driverName = payloadData.vehicle && payloadData.vehicle.driverName ? payloadData.vehicle.driverName : '';
  payloadData.startDate = payloadData.startDate ? getDateInStringDDMMMYYYY(payloadData.startDate) : "";
  payloadData.completedDate = payloadData.completedDate ? getDateInStringDDMMMYYYY(payloadData.completedDate) : '';
  payloadData.driverContactNumber = payloadData.vehicle && payloadData.vehicle.driverContactNumber ? payloadData.vehicle.driverContactNumber : ''
  return { type: constants.GET_SINGLE_TRIP_DATA, payload: payloadData };
}
export const emptySingleTripData = (response) => {
  return { type: constants.GET_SINGLE_TRIP_DATA, payload: {} };
}
export const populateSingleJourneyData = (response, store) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    var tripDetails = response.response
    logger.log("TripActionCreator", tripDetails);
    payloadData= tripDetails;
    if (payloadData.vehicle && payloadData.vehicle.vehicleNumber) {
      let vehicleNumArray = getVehicleNumberValues(payloadData.vehicle.vehicleNumber)
      let vehicleNumArrayValue = getVehicleNumberValuesDWeb(payloadData.vehicle.vehicleNumber);
      payloadData.vehicle.vehicleNumber = payloadData.vehicle.vehicleNumber;
      payloadData.vehicle.vehicleNumberPrefix = vehicleNumArray[0];
      payloadData.vehicle.vehicleNumberSuffix = vehicleNumArray[1];
      payloadData.vehicle.vehicleNumArrayDweb = vehicleNumArrayValue;
    }
    if (payloadData.trips && payloadData.trips.length>0) {
        for (let index = 0; index <  payloadData.trips.length; index++) {
          const element =  payloadData.trips[index];
          if (element&&element.transactions && element.transactions.charges && element.transactions.charges.list && element.transactions.charges.list.length>0) {
            let deductions = element.transactions.charges.list.filter((trans)=>trans&&trans.transactionParentType&&trans.transactionParentType=='DEDUCTION');
            let charges = element.transactions.charges.list.filter((trans)=>trans&&trans.transactionParentType&&trans.transactionParentType=='CHARGES');
            let dedAmount = 0;
            deductions.forEach(ded => {
              dedAmount += ded.amount;
            });
            let charAmount = 0;
            charges.forEach(char => {
              charAmount += char.amount;
            });
            element.transactions.chargesList={
              list:charges,
              totalAmount:charAmount
            }
            element.transactions.deductions={
              list:deductions,
              totalAmount:dedAmount
            }
          }
          payloadData.trips[index] = element;
        }
    }
    if (payloadData.vendor && payloadData.vendor.vendorId) {
      let transactions = payloadData && payloadData.vendorTransactions ? payloadData.vendorTransactions:[];
      let charges = transactions && transactions.charges?transactions.charges:[]
      let transData = findArrayObject("transactionType", 'Vehicle_Hire_Cost', charges && charges.list?charges.list:null);
      payloadData.truckHireCost = transData&&transData.amount?transData.amount:null
      payloadData.vendor = {
        ...payloadData.vendor,
        name:payloadData.vendor.vendorName,
        id:payloadData.vendor.vendorId
      }
    }
  } else {
    console.error("Error while fetching trip details : " + response.status.code + " : " + response.status.message)
  }
  if (typeof store != 'undefined' && !store) {
    return payloadData;
  } else {
    return { type: constants.GET_SINGLE_TRIP_DATA, payload: payloadData };
  }
}
export const populateSingleTripData = (response, store) => {
  var payloadData = {}
  if (response.status && response.status.code && response.status.code == 200 && response.response) {
    var tripDetails = response.response
    logger.log("TripActionCreator", tripDetails);
    payloadData.id = tripDetails.id
    payloadData.isDriverDeleted = tripDetails.isDriverDeleted;
    payloadData.isVendorSettled = tripDetails.isVendorSettled;
    // Basic trip details
    payloadData.partyName = (tripDetails.customer && tripDetails.customer.name) ? tripDetails.customer.name : ''
    var vehicleNumber = tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : ''
    payloadData.vehicleNumberPrefix = vehicleNumber.substring(0, vehicleNumber.length - 4)
    payloadData.vehicleNumberSuffix = vehicleNumber.substring(vehicleNumber.length - 4, vehicleNumber.length)
    payloadData.vehicleType = tripDetails.vehicle && tripDetails.vehicle.type ? tripDetails.vehicle.type : ''
    payloadData.driverName = tripDetails.vehicle && tripDetails.vehicle.driverName ? tripDetails.vehicle.driverName : ''
    payloadData.driverContactNumber = tripDetails.vehicle && tripDetails.vehicle.driverContactNumber ? tripDetails.vehicle.driverContactNumber : ''
    payloadData.startLocation = tripDetails.startLocation
    payloadData.startDate = getDateInStringDDMMMYYYY(tripDetails.startDate)
    payloadData.completedDate = tripDetails.completedDate ? getDateInStringDDMMMYYYY(tripDetails.completedDate) : ''
    payloadData.destinationLocation = tripDetails.destinationLocation
    payloadData.freightAmount = tripDetails.initialTotalAmount
    payloadData.balancePending = tripDetails.finalAmountRemaining
    payloadData.isDeletable = tripDetails.isDeletable;
    payloadData.vehicle = tripDetails.vehicle;
    payloadData.material = tripDetails.material;
    payloadData.elr_number = tripDetails.elr_number;
    payloadData.elr_id = tripDetails.elr_id;
    payloadData.vehicle_location_url = tripDetails.vehicle_location_url;
    if (tripDetails && tripDetails.elr_status) {
      payloadData.elr_status = {
        basic_details: tripDetails.elr_status.basic_details,
        consignor_consignee_details: tripDetails.elr_status.consignor_consignee_details,
        load_details_done: tripDetails.elr_status.load_details_done,
        insurance_signature_details_done: tripDetails.elr_status.insurance_signature_details_done,
        overall_status: tripDetails.elr_status.overall_status
      };
    }
    if (tripDetails.reminder_due_date) {
      payloadData.reminder_due_date = tripDetails.reminder_due_date;
    }
    payloadData.driver = {}
    if (tripDetails.driverId) {
      payloadData.driver.id = tripDetails.driverId
      payloadData.driver.name = tripDetails.driverName
      payloadData.driver.contactNumber = tripDetails.driverContactNumber
    }
    if (payloadData.vehicle && payloadData.vehicle.number) {
      let vehicleNumArray = getVehicleNumberValues(payloadData.vehicle.number)
      let vehicleNumArrayValue = getVehicleNumberValuesDWeb(payloadData.vehicle.number);
      let vehicleDisplayStatus = payloadData.vehicle.status ? constants.VEHICLE_STATUS[payloadData.vehicle.status] : '';
      payloadData.vehicle.vehicleNumber = payloadData.vehicle.number;
      payloadData.vehicle.vehicleNumberPrefix = vehicleNumArray[0];
      payloadData.vehicle.vehicleNumberSuffix = vehicleNumArray[1];
      payloadData.vehicle.vehicleNumArrayDweb = vehicleNumArrayValue;
    }
    payloadData.party = tripDetails.customer
    payloadData.vendor = tripDetails.vendor
    payloadData.tripTransactions = tripDetails.tripTransactions
    payloadData.vendorTransactions = tripDetails.vendorTransactions
    payloadData.billingType = tripDetails.billingType
    payloadData.billingDetails = tripDetails.billingDetails
    payloadData.startOdometerReading = tripDetails.startOdometerReading ? tripDetails.startOdometerReading : ""
    payloadData.endOdometerReading = tripDetails.endOdometerReading ? tripDetails.endOdometerReading : ""
    payloadData.vehicleForSelect = { ownershipType: tripDetails.vehicle.ownershipType, vehicleNumberPrefix: payloadData.vehicleNumberPrefix, vehicleNumberSuffix: payloadData.vehicleNumberSuffix, driverName: tripDetails.vehicle.driverName, driverNumber: tripDetails.vehicle.driverContactNumber, id: tripDetails.vehicle.id, vehicleBodyType: tripDetails.vehicle.vehicleBodyType, vehicleNumber: tripDetails.vehicle.number, vehicleType: tripDetails.vehicle.type }
    // Trip Progress
    payloadData.status = tripDetails.status
    payloadData.podReceivedAt = tripDetails.tripPods.length > 0 ? getDateInStringDDMMMYYYY(tripDetails.tripPods[0].podReveivedAt) : "";
    let podSubmitEvent = findArrayObject('event', 'POD_SUBMITTED', tripDetails.tripEvents);
    payloadData.podSubmittedAt = podSubmitEvent && podSubmitEvent.eventDate ? getDateInStringDDMMMYYYY(podSubmitEvent.eventDate) : ""
    // Profit Summary
    payloadData.profit = tripDetails.profitSummary.Profit ? tripDetails.profitSummary.Profit.amount : 0
    payloadData.profitSummaryExpenseAmount = tripDetails.profitSummary.Expenses.amount
    payloadData.profitSummaryExpenses = tripDetails.profitSummary.Expenses.lineItems
    payloadData.profitSummaryRevenueAmount = tripDetails.profitSummary.Revenue.amount
    payloadData.profitSummaryRevenue = tripDetails.profitSummary.Revenue.lineItems

    // Party and Supplier Summary - Party
    payloadData.partyFreightAmount = 0
    payloadData.partyAdvances = []
    payloadData.partyDeductions = []
    payloadData.partyCharges = []
    payloadData.partyPayments = []
    payloadData.nonVendorCharges = []
    payloadData.partyBalance = 0  // TODO: To be computed ****************************************************
    payloadData.totalPartyAdvances = 0
    payloadData.totalPartyDeductions = 0
    payloadData.totalPartyCharges = 0
    payloadData.totalPartyPayments = 0
    var tripTransactions = tripDetails.tripTransactions
    if (tripTransactions && tripTransactions.length > 0) {
      for (var i = 0; i < tripTransactions.length; i++) {
        if ("FREIGHT" == tripTransactions[i].transactionParentType)
          payloadData.partyFreightAmount = tripTransactions[i].totalAmount;

        var id = tripTransactions[i].id;
        var customerPaymentId = tripTransactions[i].customerPaymentId ? tripTransactions[i].customerPaymentId : ""
        var displayName = tripTransactions[i].displayName ? tripTransactions[i].displayName : tripTransactions[i].transactionType
        var paymentMode = tripTransactions[i].paymentMode ? tripTransactions[i].paymentMode : ''
        var paymentData = tripTransactions[i].paymentData ? tripTransactions[i].paymentData : ''
        var description = tripTransactions[i].description ? tripTransactions[i].description : ''
        var paymentLinkStatus = tripTransactions[i].paymentLinkStatus ? tripTransactions[i].paymentLinkStatus : ''
        var paymentDate = tripTransactions[i].paymentDate

        if ("ADVANCE" == tripTransactions[i].transactionParentType) {
          payloadData.totalPartyAdvances += tripTransactions[i].amountPaid ? parseFloat(tripTransactions[i].amountPaid) : 0;
          payloadData.partyAdvances.push({
            displayName: displayName,
            amount: pos_to_neg(tripTransactions[i].amountPaid),
            paymentMode: paymentMode,
            paymentData: paymentData,
            paymentDate: paymentDate,
            description: description,
            id: id
          })

        }
        if ("PAYMENT" == tripTransactions[i].transactionParentType) {
          payloadData.totalPartyPayments += tripTransactions[i].amountPaid ? parseFloat(tripTransactions[i].amountPaid) : 0;
          let data = {
            id: id,
            displayName: displayName,
            amount: tripTransactions[i].amountPaid ? pos_to_neg(tripTransactions[i].amountPaid) : tripTransactions[i].totalAmount ? tripTransactions[i].totalAmount : 0,
            paymentMode: paymentMode,
            paymentData: paymentData,
            description: description,
            paymentDate: paymentDate,
            customerPaymentId: customerPaymentId,
            paymentLinkStatus: paymentLinkStatus
          }
          if (tripTransactions[i].hasOwnProperty('isBrokerEnabled')) {
            data.isBrokerEnabled = tripTransactions[i].isBrokerEnabled;
          }
          payloadData.partyPayments.push({
            ...data
          })


        }
        if ("DEDUCTION" == tripTransactions[i].transactionParentType) {
          payloadData.totalPartyDeductions += tripTransactions[i].totalAmount ? parseFloat(tripTransactions[i].totalAmount) : 0;
          payloadData.partyDeductions.push({
            id: id, displayName: displayName,
            amount: pos_to_neg(tripTransactions[i].totalAmount),
            description: tripTransactions[i].description
          })
        }
        if ("CHARGES" == tripTransactions[i].transactionParentType) {
          payloadData.totalPartyCharges += tripTransactions[i].totalAmount ? parseFloat(tripTransactions[i].totalAmount) : 0;
          payloadData.partyCharges.push({
            id: id,
            displayName: displayName,
            amount: tripTransactions[i].totalAmount,
            description: tripTransactions[i].description,
            vendorTransactionId: tripTransactions[i].vendorTransactionId,
            isBillable: true
          })
        }
      }
    }

    // Non Supplier Charges - Party Expenses
    var nonVendorCharges = tripDetails.nonVendorCharges
    if (nonVendorCharges && nonVendorCharges.length > 0) {
      for (var i = 0; i < nonVendorCharges.length; i++) {
        payloadData.totalNonVendorCharges += parseFloat(nonVendorCharges[i].amount)
        payloadData.nonVendorCharges.push({
          id: nonVendorCharges[i].id,
          displayName: nonVendorCharges[i].type,
          amount: nonVendorCharges[i].amount,
          description: nonVendorCharges[i].description,
          isBillable: nonVendorCharges[i].isBillable,
          billableAmount: nonVendorCharges[i].billableAmount
        })
      }
    }

    // Party and Supplier Summary - Supplier
    payloadData.truckHireCost = tripDetails.vehicleHireCost
    // if ( payloadData.truckHireCost  && payloadData.truckHireCost > 0 )
    //         payloadData.partyCharges.push({id:null, displayName: 'Vehicle_Hire_Cost',
    //                                       amount: tripDetails.vehicleHireCost, isBillable: false }
    //                                       )
    payloadData.vendorAdvancesSummary = extractVendorSummaryData(tripDetails.vendorAdvances, "Advance")
    payloadData.vendorDeductionsSummary = extractVendorSummaryData(tripDetails.vendorDeductions, null)
    payloadData.vendorChargesSummary = extractVendorSummaryData(tripDetails.vendorCharges, null)
    payloadData.vendorPaymentsSummary = extractVendorSummaryData(tripDetails.vendorPayments, "Payment")
    payloadData.vendorBalance = tripDetails.vendorBalance
    payloadData.partyBalance = (payloadData.partyFreightAmount - Math.abs(payloadData.totalPartyDeductions) + payloadData.totalPartyCharges)
      - (payloadData.totalPartyAdvances + payloadData.totalPartyPayments)

    // Supplier Transactions
    payloadData.vendorAdvances = tripDetails.vendorAdvances;
    payloadData.vendorDeductions = tripDetails.vendorDeductions;
    payloadData.vendorPayments = tripDetails.vendorPayments;
    payloadData.vendorCharges = []
    if (tripDetails.vendorCharges && tripDetails.vendorCharges.length > 0) {
      for (var i = 0; i < tripDetails.vendorCharges.length; i++) {
        if (tripDetails.vendorCharges[i].type == 'Vehicle_Hire_Cost')
          payloadData.truckHireCostExpense = tripDetails.vendorCharges[i]
        else
          payloadData.vendorCharges.push(tripDetails.vendorCharges[i])
      }
    }

    // Trip Events
    payloadData.tripEvents = tripDetails.tripEvents;

    // Trip Notes
    if (tripDetails.notes && tripDetails.notes["STARTED"] && tripDetails.notes["STARTED"].length > 0) {
      payloadData.notes = tripDetails.notes["STARTED"][0];
    }
    if (tripDetails.notes) {
      payloadData.notes = tripDetails.notes
    }

    if (tripDetails.notes && tripDetails.notes["STARTED"] && tripDetails.notes["STARTED"].length > 0) {
      payloadData.tripGcns = tripDetails.notes["STARTED"];
    } else {
      payloadData.tripGcns = [];
    }
    // if (tripDetails.notes && tripDetails.notes[tripDetails.status] && tripDetails.notes[tripDetails.status].length > 0)
    //   var notesArray = tripDetails.notes[tripDetails.status]
    //   if (notesArray)
    //     for(var i=0; i<notesArray.length; i++)
    //       payloadData.notes += ' ' + notesArray[i].note

    // Trip PODs
    payloadData.tripPods = tripDetails.tripPods;
    payloadData.vendorBillingType = tripDetails.vendorBillingType;
    payloadData.vendorBillingDetails = tripDetails.vendorBillingDetails;
  } else {
    console.error("Error while fetching trip details : " + response.status.code + " : " + response.status.message)
  }
  if (typeof store != 'undefined' && !store) {
    return payloadData;
  } else {
    return { type: constants.GET_SINGLE_TRIP_DATA, payload: payloadData };
  }
}

const extractVendorSummaryData = (vendorData, name) => {
  var vendorSummaryData = { totalAmount: 0, lineItems: [] }
  if (vendorData && vendorData.length > 0) {
    for (var i = 0; i < vendorData.length; i++) {
      if ("Vehicle_Hire_Cost" == vendorData[i].type) continue;
      vendorSummaryData.totalAmount += parseFloat(vendorData[i].amount)
      var displayName = vendorData[i].type ? vendorData[i].type : name
      vendorSummaryData.lineItems.push({
        displayName: displayName,
        paymentMode: vendorData[i].paymentMode,
        paymentData: vendorData[i].paymentData,
        paymentDate: vendorData[i].paymentDate,
        amount: vendorData[i].amount,
        description: vendorData[i].description,
        isBillable: vendorData[i].isBillable,
        billableAmount: vendorData[i].billableAmount,
      })
    }
  }
  return vendorSummaryData;
}

export const updateTripEditArrowFlag = (arrowName, newValue) => {
  logger.log("TripActionCreator", '------>' + arrowName)
  var arraowValues = {};
  arraowValues[arrowName + ''] = newValue;
  return { type: constants.UPDATE_TRIP_EDIT_ARROW_FLAGS, payload: arraowValues };
}

export const updateTripEditModalFlag = (modalName, flag) => {
  logger.log("TripActionCreator", '------>' + modalName + '::' + flag)
  var modalValues = {};
  modalValues[modalName + ''] = flag;
  return { type: constants.UPDATE_TRIP_EDIT_MODAL_FLAGS, payload: modalValues };
}
/*------------------------------------------------- PARTY Charge --------------------------------------------*/
export const addPartyCharge = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/charge",
    data,
    success: (response) => processChargeResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editPartyCharge = (tripId, chargeId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId + "/charge/" + chargeId,
    data,
    success: (response) => processChargeResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deletePartyCharge = (tripId, chargeId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/charge/" + chargeId,
    data,
    success: (response) => processChargeResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processChargeResponse = (response) => {
  logger.log("TripActionCreator", "----> INCOMING Charge RESPONSE : " + JSON.stringify(response))
  return { type: null, payload: null };
}

/*------------------------------------------------- PARTY DEDUCTIONS --------------------------------------------*/
export const addPartyDeduction = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/deduction",
    data,
    success: (response) => processDeductionResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editPartyDeduction = (tripId, deductionId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId + "/deduction/" + deductionId,
    data,
    success: (response) => processDeductionResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deletePartyDeduction = (tripId, deductionId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/deduction/" + deductionId,
    data,
    success: (response) => processDeductionResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processDeductionResponse = (response) => {
  logger.log("TripActionCreator", "----> INCOMING DEDUCTION RESPONSE : " + JSON.stringify(response))
  return { type: null, payload: null };
}

export const updateCurrentPartyDeduction = (deduction) => {
  var currentDeduction = deduction ? deduction : { id: null, displayName: '', amount: 0, description: '' };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Party Deduction : " + JSON.stringify(currentDeduction))
  return { type: constants.UPDATE_CURRENT_PARTY_DEDUCTION, payload: currentDeduction }
}

/*------------------------------------------------- PARTY EXPENSES --------------------------------------------*/
export const addPartyExpense = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/expenses",
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editPartyExpense = (tripId, expenseId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId + "/expenses/" + expenseId,
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deletePartyExpense = (tripId, expenseId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/expenses/" + expenseId,
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processExpenseResponse = (response) => {
  logger.log("TripActionCreator", "----> INCOMING EXPENSE RESPONSE : " + JSON.stringify(response))
  return { type: null, payload: null };
}



export const updateCurrentPartyExpense = (expense) => {
  var currentExpense = expense ? expense : { id: null, displayName: '', amount: 0, description: '', isBillable: false };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Party Expense : " + JSON.stringify(currentExpense))
  return { type: constants.UPDATE_CURRENT_PARTY_EXPENSE, payload: currentExpense }
}


/*------------------------------------------------- PARTY ADVANCES --------------------------------------------*/
export const addPartyAdvance = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/advance",
    data,
    success: (response) => processAdvanceResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editPartyAdvance = (tripId, advanceId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId + "/advance/" + advanceId,
    data,
    success: (response) => processAdvanceResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deletePartyAdvance = (tripId, advanceId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/advance/" + advanceId,
    data,
    success: (response) => processAdvanceResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processAdvanceResponse = (response) => {
  logger.log("TripActionCreator", "----> INCOMING ADVANCE RESPONSE : " + JSON.stringify(response))
  return { type: null, payload: null };
}

export const updateCurrentPartyAdvance = (advance) => {
  var currentAdvance = advance ? advance : { id: null, displayName: '', amount: 0, paymentMode: '', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Party Advance : " + JSON.stringify(currentAdvance))
  return { type: constants.UPDATE_CURRENT_PARTY_ADVANCE, payload: currentAdvance }
}

/*------------------------------------------------- PARTY PAYMENTS --------------------------------------------*/
export const addPartyPayment = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/payment",
    data,
    success: (response) => processPaymentResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editPartyPayment = (tripId, paymentId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId + "/payment/" + paymentId,
    data,
    success: (response) => processPaymentResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deletePartyPayment = (tripId, paymentId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/payment/" + paymentId,
    data,
    success: (response) => processPaymentResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

// const processPaymentResponse = (response) => {
//   logger.log("TripActionCreator", "----> INCOMING PAYMENT RESPONSE : " + JSON.stringify(response))
//   return { type: null, payload: null };
// }

export const updateCurrentPartyPayment = (payment) => {
  var currentPayment = payment ? payment : { id: null, displayName: '', amount: 0, paymentMode: '', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Party Payment : " + JSON.stringify(currentPayment))
  return { type: constants.UPDATE_CURRENT_PARTY_PAYMENT, payload: currentPayment }
}


/*------------------------------------------------- VENDOR DEDUCTIONS --------------------------------------------*/
export const addVendorDeduction = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor_deduction",
    data,
    success: (response) => processDeductionResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editVendorDeduction = (deductionId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/vendor_deduction/" + deductionId,
    data,
    success: (response) => processDeductionResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deleteVendorDeduction = (deductionId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/vendor_deduction/" + deductionId,
    data,
    success: (response) => processDeductionResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

//   const processDeductionResponse = (response) => {
//     logger.log("TripActionCreator", "----> INCOMING DEDUCTION RESPONSE : " + JSON.stringify(response))
//     return { type: null, payload: null };
//   }

export const updateCurrentVendorDeduction = (deduction) => {
  var currentDeduction = deduction ? deduction : { id: null, displayName: '', amount: 0, description: '' };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Supplier Deduction : " + JSON.stringify(currentDeduction))
  return { type: constants.UPDATE_CURRENT_VENDOR_DEDUCTION, payload: currentDeduction }
}
export const tripExpenseTypes = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trip/expense_types",
    success: (response) => processTripExpenseTypes(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const addTripExpenseTypes = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trip/add_expense_type",
    data,
    success: (response) => processAddExpenseTypeResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
const processAddExpenseTypeResponse = (response) => {
  return { type: null, payload: null };
}
const processTripExpenseTypes = (response) => {
  let payLoadData = [];
  if (response.response) {
    if (response.response.recentlyUsed && Array.isArray(response.response.recentlyUsed)) {
      response.response.recentlyUsed.forEach(item => {
        item.group = 'Recently Used'
        payLoadData.push(item)
      });
    }
    if (response.response.recommended && Array.isArray(response.response.recommended)) {
      response.response.recommended.forEach(item => {
        item.group = 'Recommended'
        payLoadData.push(item)
      });
    }
  }
  return { type: constants.TRIP_EXPENSE_TYPES, payload: payLoadData };
}
/*------------------------------------------------- VENDOR EXPENSES --------------------------------------------*/
export const addVendorExpense = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor_expense",
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

// export const addExpenseV1 = (data, onSuccess, onError) => ({
//   type: constants.API,
//   payload: {
//     method: "POST",
//     url: `/v2/vehicle/${data && data.vehicleId?data.vehicleId:''}/expense`,
//     data,
//     success: (response) => processExpenseResponse(response),
//     postProcessSuccess: onSuccess,
//     postProcessError: onError,
//   },
// });
// export const editExpenseV1 = (expenseId, data, onSuccess, onError) => ({
//   type: constants.API,
//   payload: {
//     method: "PUT",
//     url: `/v2/vehicle/${data && data.vehicleId?data.vehicleId:''}/expense/${expenseId}`,
//     data,
//     success: (response) => processExpenseResponse(response),
//     postProcessSuccess: onSuccess,
//     postProcessError: onError,
//   },
// });
export const getVendorExpense = (expenseId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/vendor_expense/" + expenseId,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const editVendorExpense = (expenseId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/vendor_expense/" + expenseId,
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const addExpenseV1 = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: `/v2/vehicle/${data && data.vehicleId ? data.vehicleId : ''}/expense`,
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const editExpenseV1 = (expenseId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: `/v2/vehicle/${data && data.vehicleId ? data.vehicleId : ''}/expense/${expenseId}`,
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deleteVendorExpense = (expenseId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/vendor_expense/" + expenseId,
    data,
    success: (response) => processExpenseResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

//   const processExpenseResponse = (response) => {
//     logger.log("TripActionCreator", "----> INCOMING EXPENSE RESPONSE : " + JSON.stringify(response))
//     return { type: null, payload: null };
//   }

export const updateCurrentVendorExpense = (expense) => {
  var currentExpense = expense ? expense : { id: null, displayName: '', amount: 0, description: '', isBillable: false };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Supplier Expense : " + JSON.stringify(currentExpense))
  return { type: constants.UPDATE_CURRENT_VENDOR_EXPENSE, payload: currentExpense }
}


/*------------------------------------------------- VENDOR ADVANCES --------------------------------------------*/
export const addVendorAdvance = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor_advance",
    data,
    success: (response) => processAdvanceResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editVendorAdvance = (advanceId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/vendor_advance/" + advanceId,
    data,
    success: (response) => processAdvanceResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deleteVendorAdvance = (advanceId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/vendor_advance/" + advanceId,
    data,
    success: (response) => processAdvanceResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

//   const processAdvanceResponse = (response) => {
//     logger.log("TripActionCreator", "----> INCOMING ADVANCE RESPONSE : " + JSON.stringify(response))
//     return { type: null, payload: null };
//   }

export const updateCurrentVendorAdvance = (advance) => {
  var currentAdvance = advance ? advance : { id: null, displayName: '', amount: 0, paymentMode: 'Cash', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Supplier Advance : " + JSON.stringify(currentAdvance))
  return { type: constants.UPDATE_CURRENT_VENDOR_ADVANCE, payload: currentAdvance }
}

/*------------------------------------------------- VENDOR PAYMENTS --------------------------------------------*/
export const addVendorPayment = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/vendor_payment",
    data,
    success: (response) => processPaymentResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const editVendorPayment = (paymentId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/vendor_payment/" + paymentId,
    data,
    success: (response) => processPaymentResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const deleteVendorPayment = (paymentId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/vendor_payment/" + paymentId,
    data,
    success: (response) => processPaymentResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processPaymentResponse = (response) => {
  logger.log("TripActionCreator", "----> INCOMING PAYMENT RESPONSE : " + JSON.stringify(response))
  return { type: null, payload: null };
}

export const updateCurrentVendorPayment = (payment) => {
  var currentPayment = payment ? payment : { id: null, displayName: '', amount: 0, paymentMode: '', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Supplier Payment : " + JSON.stringify(currentPayment))
  return { type: constants.UPDATE_CURRENT_VENDOR_PAYMENT, payload: currentPayment }
}

export const updateCurrentTruckHireCostExpense = (truckHireCost) => {
  var currentHireCost = truckHireCost ? truckHireCost : { id: null, displayName: '', amount: 0, paymentMode: '', paymentData: '', paymentDate: null };
  logger.log("TripActionCreator", "---------> BEFORE UPDATING current Truck Hire Cost : " + JSON.stringify(currentHireCost))
  return { type: constants.UPDATE_CURRENT_TRUCK_HIRE_COST_EXPENSE, payload: currentHireCost }
}

// --------------------------------------------- CREATE TRIP v2 ---------------------------------------------
export const createTrip = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips-v2",
    data,
    success: (response) => processCreateTripResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const createLoad = (journeyId,data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: `/journey/${journeyId}/trip`,
    data,
    success: (response) => processCreateLoadResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const processCreateLoadResponse = (response) => {
  logger.log("TripActionCreator", "--------> Create Trip Response : " + JSON.stringify(response));
  var createTripResponse = {}
  if (response.status && response.status.code == 200 && response.response)
    createTripResponse = { id: response.response.id }
  return { type: null, payload: null }

}

const processCreateTripResponse = (response) => {
  logger.log("TripActionCreator", "--------> Create Trip Response : " + JSON.stringify(response));
  var createTripResponse = {}
  if (response.status && response.status.code == 200 && response.response)
    createTripResponse = { id: response.response.id }
  return { type: constants.UPDATE_CREATE_TRIP_RESPONSE, payload: createTripResponse }

}

// ---------------------------------------- Mark Trip Complete ---------------------------------

export const updateTripStatus = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId + "/status",
    data,
    success: (response) => { logger.log("TripActionCreator", "----> TRIP Status Response : " + JSON.stringify(response)); return { type: null, payload: null }; },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

// ---------------------------------------- Update Trip Notes ---------------------------------

export const updateTripNotes = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: data.id ? "PUT" : "POST",
    url: data.id ? "/trips/" + tripId + "/note/" + data.id : "/trips/" + tripId + "/note",
    data,
    success: (response) => { logger.log("TripActionCreator", "----> TRIP Notes Response : " + JSON.stringify(response)); return { type: null, payload: null }; },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const createTripNotes = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/note",
    data,
    success: (response) => { return { type: null, payload: null }; },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const deleteTripLrGcn = (tripId, tripLrGcnId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/note/" + tripLrGcnId,
    data,
    success: (response) => { return { type: null, payload: null }; },
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const updateCreateTripTransactions = (type, payload) => {
  logger.log("TripActionCreator", "--> Updating the create trip data for : " + type + " :: " + payload);
  return { type: type, payload: payload };
}

export const updateCreateTripTransactionIndex = (type, payload) => {
  logger.log("TripActionCreator", "--> Updating the create trip edit transaction data for : " + type + " :: " + payload);
  return { type: type, payload: payload };
}

export const updateCreateTripData = (createTripData) => {
  logger.log("TripActionCreator", "--> Updating create trip data :: " + JSON.stringify(createTripData));
  return { type: constants.UPDATE_CREATE_TRIP_DATA, payload: createTripData };
}

/**
 * Function to add new party
 */
export const addNewParty = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/customermapping",
    data,
    success: (response) => processNewParty(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});



const processNewParty = (response) => {
  if (response.status && response.status.code && response.status.code == 200) {
    logger.log("TripActionCreator", "--> Party Creation Success");
  }
  return { type: constants.ADD_PARTY, payload: response.response };
};

export const addNewShop = (data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/khata/shop",
    data,
    success: (response) => processNewShop(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});



const processNewShop = (response) => {
  if (response.status && response.status.code && response.status.code == 200) {
    logger.log("TripActionCreator", "--> KHATA_SHOP Creation Success");
  }
  return { type: constants.ADD_SHOP, payload: response.response };
};

/**
 * Function to toggle add party dialog open and close
 */
export const udpateAddPartyFlag = (searchText) => { return { type: constants.UPDATE_ADD_PARTY_FLAG, payload: searchText }; };

export const deleteCurrentTripTransactions = () => {
  logger.log("TripActionCreator", "--> Deleting create trip data :: ");
  return { type: constants.DELETE_CREATE_TRIP_TRANSACTIONS };
}

export const deleteCreateTripTruckHireCost = () => {
  logger.log("TripActionCreator", "--> Deleting create trip data :: truck hire cost ");
  return { type: constants.DELETE_CREATE_TRIP_TRUCK_HIRE_COST };
}

/**
 * Function to add new PODs to the trips
 * @param {*} tripId
 * @param {*} data
 * @param {*} onSuccess
 * @param {*} onError
 */
export const addNewPod = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/trippod",
    data,
    success: (response) => processAddPodResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
export const addNewPodDweb = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/trippod",
    data,
    success: (response) => processAddPodResponseDweb(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});
const processAddPodResponseDweb = (response) => {
  return { type: null, payload: null };
};

const processAddPodResponse = (response) => {
  if (response.status && response.status.code && response.status.code == 200) {
    logger.log("TripActionCreator", "--> New POD addition Success");
  }
  return { type: constants.ADD_TRIP_POD, payload: response.response };
};

/**
 * Function to add delete existing PODs
 * @param {*} tripId
 * @param {*} tripPodId
 * @param {*} onSuccess
 * @param {*} onError
 */
export const deleteTripPod = (tripId, tripPodId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/trippod/" + tripPodId,
    data,
    success: (response) => processDeletePodResponse(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processDeletePodResponse = (response) => {
  if (response.status && response.status.code && response.status.code == 200 && response.response && response.response.isDeleted) {
    logger.log("TripActionCreator", "--> Delete POD Success");
  }
  return { type: null, payload: null };
};

/**
 * Update the current trip PODs for CTA
 * @param {*} pods
 */
export const updateTripPodsCTA = (pods) => { return { type: constants.ADD_TRIP_POD_CTA, payload: pods }; }

export const updateNoteTrip = (tripId, noteId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/trips/" + tripId + "/note/" + noteId,
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const addNewNoteTrip = (tripId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trips/" + tripId + "/note",
    data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});


export const getTripPdf = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trips/" + tripId + "/pdf",
    success: (response) => processTripPdfData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});
export const paymentCancel = (paymentId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/customer-payment/" + paymentId + "/cancel",
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processTripPdfData = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_TRIP_PDF, payload: payloadData }
}


// ************************************************ Online Bilty APIs ************************************************
export const loadElr = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/elr/' + tripId + '/lr_info',
    success: (response) => processLoadElr(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

const processLoadElr = (response) => {
  const payloadData = response.response;
  return { type: constants.LOAD_ELR, payload: payloadData }
}

export const gstInfoElr = (gstNumber, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/elr/gst_info/' + gstNumber,
    success: (response) => processGstInfoElr(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

const processGstInfoElr = (response) => {
  let payloadData = response.response;
  return { type: constants.ELR_GST_INFO, payload: payloadData }
}

export const addElr = (companyDetailsData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'POST',
    url: '/elr',
    data: companyDetailsData,
    success: (response) => processAddElr(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

const processAddElr = (response) => {
  let payloadData = response.response;
  return { type: null, payload: null }
}

export const editElr = (elrId, companyDetailsData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'PUT',
    url: '/elr/' + elrId,
    data: companyDetailsData,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

export const getConsigneeList = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/elr/consignees',
    success: (response) => processConsigneeList(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

const processConsigneeList = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_CONSIGNEE_LIST, payload: payloadData }
}

export const getConsignorList = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/elr/consignors',
    success: (response) => processConsignorList(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

const processConsignorList = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_CONSIGNOR_LIST, payload: payloadData }
}

export const addConsignee = (details, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'POST',
    url: '/elr/consignee',
    data: details,
    success: (response) => processAddConsignee(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

export const addConsignor = (details, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'POST',
    url: '/elr/consignor',
    data: details,
    success: (response) => processAddConsignor(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

export const editConsignee = (consigneeId, details, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: '/elr/consignee/' + consigneeId,
    data: details,
    success: (response) => processAddConsignee(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

export const editConsignor = (consignorId, details, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'PUT',
    url: '/elr/consignor/' + consignorId,
    data: details,
    success: (response) => processAddConsignor(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

const processAddConsignee = (response) => {
  let payloadData = response.response;
  return { type: constants.ADD_CONSIGNEE, payload: payloadData }
}

const processAddConsignor = (response) => {
  let payloadData = response.response;
  return { type: constants.ADD_CONSIGNOR, payload: payloadData }
}

export const getMaterials = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/elr/products',
    success: (response) => processMaterialList(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

export const getElrInfo = (elrId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/elr/' + elrId,
    success: (response) => processElrInfo(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

export const addMaterial = (materialData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'POST',
    url: '/elr/products',
    data: materialData,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

export const getInsuranceProviders = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/elr/insurance_providers',
    success: (response) => processInsuranceProvidersList(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

export const addNewInsuranceProvider = (providerData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'POST',
    url: '/elr/insurance_providers',
    data: providerData,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

export const getConsignorPdf = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/trips/' + tripId + '/elr_consignor_pdf',
    success: (response) => processConsignorPdf(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
});

export const getCongineePdf = (tripId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: 'GET',
    url: '/trips/' + tripId + '/elr_consignee_pdf',
    success: (response) => processConsigneePdf(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError
  }
})

const processConsigneePdf = (response) => {
  const payloadData = response.response;
  return { type: constants.GET_CONSIGNEE_PDF, payload: payloadData }
}

const processConsignorPdf = (response) => {
  const payloadData = response.response;
  return { type: constants.GET_CONSIGNOR_PDF, payload: payloadData }
}

const processInsuranceProvidersList = (resposne) => {
  const payloadData = resposne.response;
  return { type: constants.GET_INSURANCE_PROVIDERS, payload: payloadData }
}

const processElrInfo = (response) => {
  let payloadData = response.response;
  return { type: constants.ELR_INFO, payload: payloadData }
}

const processMaterialList = (response) => {
  let payloadData = response.response;
  return { type: constants.MATERIAL_LIST, payload: payloadData }
}

export const biltyDataPopulated = (value) => {
  return { type: constants.BILTY_DATA_POPULATED, payload: value }
}

export const biltyContinueClick = (value) => {
  return { type: constants.BILTY_CONTINUE_CLICK, payload: value }
}

export const deleteTripNote = (tripId, noteId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/trips/" + tripId + "/note/" + noteId,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const getChargeTypes = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trip/charge_types",
    success: (response) => handleChargeTypes(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const handleChargeTypes = (response) => {
  let payloadData = [];

  if (response.response) {
    if (response.response.recentlyUsed && Array.isArray(response.response.recentlyUsed)) {
      response.response.recentlyUsed.forEach(item => {
        if(item&&item.value&&item.display && !spaceOnly(item.value) && !spaceOnly(item.display)){
          item.group = 'Recently Used'
          payloadData.push(item)
        }  
      });
    }
    if (response.response.recommended && Array.isArray(response.response.recommended)) {
      response.response.recommended.forEach(item => {
        if(item&&item.value&&item.display && !spaceOnly(item.value) && !spaceOnly(item.display)){
          item.group = 'Recommended'
          payloadData.push(item)
        }
      });
    }
  }

  return { type: constants.TRIP_CHARGE_TYPES, payload: payloadData };

}

export const getDeductionTypes = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trip/deduction_types",
    success: (response) => handleDeductionTypes(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

const handleDeductionTypes = (response) => {
  let payloadData = [];

  if (response.response) {
    if (response.response.recentlyUsed && Array.isArray(response.response.recentlyUsed)) {
      response.response.recentlyUsed.forEach(item => {
        if(item&&item.value&&item.display && !spaceOnly(item.value) && !spaceOnly(item.display)){
        item.group = 'Recently Used'
        payloadData.push(item)
        }
      });
    }
    if (response.response.recommended && Array.isArray(response.response.recommended)) {
      response.response.recommended.forEach(item => {
        if(item&&item.value&&item.display && !spaceOnly(item.value) && !spaceOnly(item.display)){
        item.group = 'Recommended'
        payloadData.push(item)
        }
      });
    }
  }
  return { type: constants.TRIP_DEDUCTION_TYPES, payload: payloadData };
}

export const addChargeType = (typeValue, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trip/add_charge_type",
    data: typeValue,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const addDeductionType = (typeValue, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/trip/add_deduction_type",
    data: typeValue,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const fetchTruckIncomeReport = (filterValue, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/v2/user-org/reports/income/truck",
    data: filterValue,
    success: (response) => processTruckIncomeReport(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processTruckIncomeReport = (response) => {
  let payloadData = response.response;
  return { type: constants.TRUCK_INCOME_REPORT, payload: payloadData }
}

export const fetchTripDefaults = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/trip/defaults",
    success: (response) => processTripDefaults(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

const processTripDefaults = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_TRIP_DEFAULTS, payload: payloadData }
}

export const getInvoiceList = (invoiceReqData, invoiceStatus, onSuccess, onError) => {

  let query = ""
  if (invoiceReqData) {
    if (invoiceReqData.searchText) {
      query += `&searchText=${invoiceReqData.searchText}`
    }
    if (invoiceReqData.pageSize) {
      query += query ? `&pageSize=${invoiceReqData.pageSize}` : `&pageSize=${invoiceReqData.pageSize}`
    }
    if (invoiceReqData.pageNo) {
      query += query ? `&pageNo=${invoiceReqData.pageNo}` : `&pageNo=${invoiceReqData.pageNo}`
    }
  }
  return ({
    type: constants.API,
    payload: {
      method: "GET",
      url: "/invoices?invoiceStatus=" + invoiceStatus + "&latestFirst=true" + query,
      success: (response) => processFetchInvoices(response, invoiceReqData && invoiceReqData.merge ? invoiceReqData.merge : false),
      postProcessSuccess: onSuccess,
      postProcessError: onError,
    },
  })
};

const processFetchInvoices = (response, merge) => {
  let payloadData = {};

  if (response.status && response.status.code && response.status.code == 200 && response.response)
    payloadData = response.response;
  else
    console.error("Error while fetching invoice ledger data : " + response.status.code + " : " + response.status.message)

  return { type: constants.GET_INVOICES_LIST, payload: { invoiceData: payloadData, merge: merge } }
}

export const invoicesDefault = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/invoice/defaults",
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const fetchInvoiceTrips = (customerId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/invoice/customer/" + customerId + "/trips",
    success: (response) => processFetchInvoiceTrips(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processFetchInvoiceTrips = (response) => {
  let payloadData = response.response;

  if (payloadData && payloadData.trips && payloadData.trips.length > 0) {
    for (var i = 0; i < payloadData.trips.length; i++) {
      payloadData.trips[i].vehicleNumArray = payloadData && payloadData.trips[i] && payloadData.trips[i].truckNumber ? getVehicleNumberValuesDWeb(payloadData.trips[i].truckNumber) : []
    }
  }

  return { type: constants.GET_INVOICES_TRIPS, payload: payloadData }
}

export const createInvoice = (invoiceData, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "POST",
    url: "/invoice",
    data: invoiceData,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

export const getInvoiceCustomers = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/invoice/customers",
    success: (response) => processInvoiceCustomers(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

const processInvoiceCustomers = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_INVOICE_CUSTOMERS, payload: payloadData }
}

export const getSingleInvoice = (invoiceId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/invoice/" + invoiceId,
    success: (response) => processSingleInvoice(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

const processSingleInvoice = (response) => {
  let payloadData = response.response;
  let gstDisplayValues = [];

  if (payloadData && payloadData.gstInfo && payloadData.gstInfo.gstType && payloadData.gstInfo.addGST) {
    if ((payloadData.gstInfo.gstType).toLowerCase() == "igst") {
      gstDisplayValues.push({ displayName: payloadData.gstInfo.gstType + '@' + payloadData.gstInfo.gstPercentage + '%', gstAmount: (payloadData.amounts.revenue * (payloadData.gstInfo.gstPercentage / 100)).toFixed(2) });
    } else {
      const halfGstPercentage = payloadData.gstInfo.gstPercentage ? ((payloadData.gstInfo.gstPercentage) / 2).toFixed(2) : ""
      gstDisplayValues.push({ displayName: "SGST@" + halfGstPercentage + '%', gstAmount: (payloadData.amounts.revenue * (halfGstPercentage / 100)).toFixed(2) })
      gstDisplayValues.push({ displayName: "CGST@" + halfGstPercentage + '%', gstAmount: (payloadData.amounts.revenue * (halfGstPercentage / 100)).toFixed(2) })
    }

    payloadData.gstInfo.gstDisplayInfo = gstDisplayValues

  }

  for (var i = 0; i < (payloadData && payloadData.trips && payloadData.trips.length ? payloadData.trips.length : 0); i++) {
    for (var j = 0; j < (payloadData && payloadData.trips && payloadData.trips[i].transactions && payloadData.trips[i].transactions.deductions && payloadData.trips[i].transactions.deductions.length ? payloadData.trips[i].transactions.deductions.length : 0); j++) {
      payloadData.trips[i].transactions.deductions[j].amount = payloadData.trips[i].transactions.deductions[j].amount * -1;
    }
  }

  return { type: constants.GET_SINGLE_INVOICE, payload: payloadData }
}

export const toggleEditInvoiceFlag = (invoiceEditFlag) => {
  return { type: constants.TOGGLE_EDIT_INVOICE_FLAG, payload: invoiceEditFlag }
}

export const deleteInvoice = (invoiceId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "DELETE",
    url: "/invoice/" + invoiceId,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

export const getInvoicePdf = (invoiceId, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: "/invoice/" + invoiceId + "/pdf",
    success: (response) => processGetInvoicePdf(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
})

const processGetInvoicePdf = (response) => {
  let payloadData = response.response;
  return { type: constants.GET_SINGLE_INVOICE_PDF, payload: payloadData }
}

export const editInvoice = (invoiceId, data, onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "PUT",
    url: "/invoice/" + invoiceId,
    data: data,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  },
});

/*export const partyListingPagination = (onSuccess, onError) => ({
  type: constants.API,
  payload: {
    method: "GET",
    url: `/list/customer?pageNo=${pageNumber}&pageSize=${pageSize}}&search=${searchText}`,
    success: (response) => processUselessData(response),
    postProcessSuccess: onSuccess,
    postProcessError: onError,
  }
});*/

const processUselessData = (response) => {
  logger.log('TripActionCreator', 'Useless data' + response);
  return { type: null, payload: null }
}
